import * as maplibre from './maplibre';
import * as ol from './ol';

export * as maplibre from './maplibre';
export * as ol from './ol';

export default {
  maplibre,
  ol,
};
